// extracted by mini-css-extract-plugin
export default {"separateButtons":"styles_separateButtons__MJjrW","cardInputStripe":"styles_cardInputStripe__PtNy5","errorText":"styles_errorText__V173-"};